import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDaIvSdKbC3Y9vGVSy-C9YPtkapH-n-Aag",
  authDomain: "zaro-lab.firebaseapp.com",
  projectId: "zaro-lab",
  storageBucket: "zaro-lab.firebasestorage.app",
  messagingSenderId: "257896476133",
  appId: "1:257896476133:web:05b8df42c51fbbd7f9d30c",
  measurementId: "G-WX7KD6GJ5T",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
